export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const SHOW_ALERT = "SHOW_ALERT";

export function toggleModal(payload) {
  return { type: TOGGLE_MODAL, payload };
}

export function enableVenueCollectionFeature(payload) {
  return { type: 'ENABLE_VENUE_FEATURE', payload };
}